
// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from "../core/UserComponent";
import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CharacterBreathe extends UserComponent {

	constructor(gameObject: Phaser.GameObjects.Image) {
		super(gameObject);

		this.gameObject = gameObject;
		(gameObject as any)["__CharacterBreathe"] = this;

		/* START-USER-CTR-CODE */
		this.scene.time.delayedCall(Phaser.Math.FloatBetween(0,2000), this.startBreathe, undefined, this);
		/* END-USER-CTR-CODE */
	}

	static getComponent(gameObject: Phaser.GameObjects.Image): CharacterBreathe {
		return (gameObject as any)["__CharacterBreathe"];
	}

	private gameObject: Phaser.GameObjects.Image;
	public breatheXAmount: number = 0.99;
	public breatheYAmount: number = 1.01;
	public duration: number = 2000;

	/* START-USER-CODE */

	startBreathe()
	{
		this.scene.add.tween({
			targets:this.gameObject,
			scaleX:this.breatheXAmount,
			scaleY:this.breatheYAmount,
			duration:this.duration,
			loop:-1,
			yoyo:true,
			ease: Phaser.Math.Easing.Quadratic.InOut
		})
	}	

	/* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
